import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getAddress, saveAddress } from './../../reducers/addresses';
import { AddressForm } from './../../components/forms';
import { FormattedMessage } from 'react-intl';
import { history } from './../../configuration/store';

class AddressPage extends React.Component {
    componentDidMount() {
        const { match, getAddress } = this.props;

        if (match && match.params && match.params.id !== 'new') {
            getAddress(match.params.id);
        }
    }

    render() {
        const { match, saveAddress, address, role } = this.props;
        let value = address ? address : { ref_id: role.id, ref_type: role.type };

        return (
            <div className="page">
                <div className="row">
                    <div className="col-xs-12">
                        <FormattedMessage id={'address'} defaultMessage={'Address'} tagName={'h4'} />
                    </div>
                    <AddressForm
                        onSubmit={values => saveAddress(values, history.push('/addresses'))}
                        cancel={() => history.push('/addresses')}
                        form={`address-form-${match.params.id}`}
                        initialValues={value}
                    />
                </div>
            </div>
        );
    }
}

const filterOutAddress = (state, props) => {
    // Attempt loading draft address
    if (state.addresses && state.addresses.draft && state.addresses.draft.id === props.match.params.id) {
        return state.addresses.draft;
    }

    return undefined;
};

AddressPage.meta = {
    hide: true,
    locations: ['/address/']
};

const mapStateToProps = (state, props) => ({
    role: state.identity.role,
    address: filterOutAddress(state, props)
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAddress: getAddress,
            saveAddress: saveAddress
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(AddressPage);



// WEBPACK FOOTER //
// ./src/pages/address/index.jsx